export const APPOINTMENT_CARDS = [
  {
    n: '01',
    title: 'Kundli Reading',
    desc: 'Detailed analysis of your birth chart for life guidance.',
    icon: 'M12 2v2M12 20v2M2 12h2M20 12h2',
    circle: true,
  },
  {
    n: '02',
    title: 'Career Guidance',
    desc: 'Predicting professional growth and financial stability.',
    icon: 'M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2',
    rect: { width: 20, height: 14, x: 2, y: 6, rx: 2 },
  },
  {
    n: '03',
    title: 'Marriage',
    desc: 'Compatibility matching and relationship problem solutions.',
    icon: 'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z',
  },
  {
    n: '04',
    title: 'Health Issues',
    desc: 'Astrological remedies for chronic health challenges.',
    icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  },
  {
    n: '05',
    title: 'Vastu Shastra',
    desc: 'Energizing your living spaces for peace and prosperity.',
    icon: 'M3 10a2 2 0 0 1 .7-1.5l7-6a2 2 0 0 1 2.6 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9z',
  },
  {
    n: '06',
    title: 'Palmistry',
    desc: 'Hand analysis to reveal character and destiny.',
    icon: 'M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4M14 13.12c0 2.38 0 6.38-1 8.88',
  },
  {
    n: '07',
    title: 'Gemstones',
    desc: 'Identifying suitable stones to balance planetary effects.',
    icon: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  },
  {
    n: '08',
    title: 'Face Reading',
    desc: 'Character and destiny analysis through facial features.',
    icon: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2',
    circleUser: { cx: 12, cy: 7, r: 4 },
  },
]
